import { AddToCartPageType } from '../typings/AddToCartPageSection';

export function getAddToCartPageType({ isBusiness }: { isBusiness: boolean }): AddToCartPageType {
  if (isBusiness) {
    return AddToCartPageType.BUSINESS_ATC_PAGE;
  }

  return AddToCartPageType.CUSTOMER_ATC_PAGE;
}
